import Block from './Block'
import SlideManager from '../util/SlideManager'
import gsap from 'gsap'
import store from '../store'

export default class TestimoniesSlider extends Block {
  onEnterCompleted() {
    this.currentIndex = 0

    this.createSlider()
    this.breakpoints()
    this.resize()
  }

  getElems() {
    this.wrapper = this.el.querySelector('.b-testimonies__slider')
    this.$items = this.el.querySelectorAll('.b-testimonies__card')
    this.pagerPrev = this.el.querySelector('.pager--prev')
    this.pagerNext = this.el.querySelector('.pager--next')
  }

  events() {
    this.pagerPrev.addEventListener('click', this.prevSlide.bind(this))
    this.pagerNext.addEventListener('click', this.nextSlide.bind(this))
  }

  createSlider() {
    this.slider = new SlideManager({
      el: this.wrapper,
      callback: (event) => {
        this.currentIndex = event.new
        this.direction = event.direction
        this.transform = - this.currentIndex * this.itemWidth

        this.breakpoints()

        this.onSlideChange()
        this.slider.done()
      }
    })
  }

  breakpoints() {
    if (store.w.ww > 768) this.canSlide = this.currentIndex < this.$items.length - 2
    else this.canSlide = true
  }

  updatePagers() {
    this.pagerPrev.classList.toggle('disable', this.currentIndex === 0)
    this.pagerNext.classList.toggle('disable', store.w.ww > 768 ? this.currentIndex === this.$items.length - 2 : this.currentIndex === this.$items.length - 1)
  }

  onSlideChange() {
    for (let i = 0; i < this.$items.length; i++) {
      let y = 0

      if (store.w.ww >= 768) {
        if (this.currentIndex % 2 === 0) y = i % 2 === 0 ? 0 : 0
        else y = i % 2 === 0 ? 180 : -180
      } else y = 0

      this.$items[i].classList.toggle('active', store.w.ww > 768 && (this.currentIndex === i || this.currentIndex + 1 === i))

      this.updatePagers()

      gsap.to(this.$items[i], {
        x: this.transform,
        y,
        ease: 'power3.inOut',
        duration: 1,
        delay: 0.05 * i * this.direction
      })
    }
  }

  prevSlide() {
    this.slider.prev()
  }

  nextSlide() {
    this.canSlide && this.slider.next()
  }

  resize() {
    this.breakpoints()

    this.itemWidth = store.w.ww >= 768 ? this.$items[0].offsetWidth + store.w.ww / 24 + 10 : this.$items[0].offsetWidth + 10

    this.slider && this.slider.goTo(0)
  }
}
